/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useEffect, useCallback, useState, type Dispatch, type SetStateAction } from 'react';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { updateHelpButtonState } from '../../services/help-button-state/index.tsx';

type AccountId = string;

export const HELP_BUTTON_UI_STORAGE_KEY = 'help_button_ui_state';

export const useHelpButtonState = (
	relayInitialValue?: number | null,
): {
	releaseNotesNotifications: number | null;
	setReleaseNotesNotifications: Dispatch<SetStateAction<number | null>>;
} => {
	const [releaseNotesNotifications, setReleaseNotesNotifications] = useState<number | null>(null);
	// Derive the initial notification value from the pre-parsed Relay value.
	// We normalise null → undefined so that the sentinel-value branch in updateData()
	// fires (mapping undefined → 100), matching the existing behaviour when the server
	// returns no releaseNotesNotifications value.
	const userReleaseNotesNotifications: number | undefined = relayInitialValue ?? undefined;
	const accountId: AccountId | null = useAccountId();

	const updateData = useCallback(() => {
		const newReleaseNotesNotificationsValue =
			userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;

		if (releaseNotesNotifications !== null) {
			if (newReleaseNotesNotificationsValue !== releaseNotesNotifications) {
				const remoteData = {
					helpPanelMenu: {
						releaseNotesNotifications,
					},
				};

				updateHelpButtonState(accountId, remoteData);
			}
		} else {
			setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
		}
	}, [accountId, releaseNotesNotifications, userReleaseNotesNotifications]);

	useEffect(() => {
		updateData();
	}, [updateData]);

	return { releaseNotesNotifications, setReleaseNotesNotifications };
};
